import React, {Component} from 'react';
import _ from "lodash";
import axios from 'axios';
import PropTypes from "prop-types";
import './SingleFileUpload.scss';

class SingleFileUpload extends Component {

    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.state = {
            selectedFile: null,
            imagePreviewUrl: null,
            uploading: false
        };

        this.onFileSelected = this.onFileSelected.bind(this);
        this.openFileDialog = this.openFileDialog.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.upload = this.upload.bind(this);
    }

    isDisabled() {
        return this.props.disabled || this.state.uploading;
    }

    remove() {
        this.setState({
            uploading: false,
            selectedFile: null,
            imagePreviewUrl: null
        });
        this.props.onChange(null);
    }

    upload(file) {
        this.setState({uploading: true}, () => {
            let formData = new FormData();
            formData.append('file', file);
            axios.post(process.env.REACT_APP_API_TEMP_UPLOAD_URL,
                formData, {headers: {'Content-Type': 'multipart/form-data'}}
            ).then((result) => {
                this.setState({
                    uploading: false
                });
                this.props.onChange({temporaryFile: result.data});
            }).catch(() => {
                this.setState({
                    uploading: false,
                    selectedFile: null,
                    imagePreviewUrl: null
                });
            });
        });
    }

    openFileDialog() {
        if (this.isDisabled()) return;
        this.fileInputRef.current.click();
    }

    static isImage(mimetype) {
        return _.includes(['image/bmp', 'image/png', 'image/jpeg', 'image/jpg', 'image/gif'], mimetype);
    }

    onFileSelected(evt) {
        const file = evt.target.files.item(0);
        this.setState({
            selectedFile: file,
            imagePreviewUrl: null
        });
        this.upload(file);

        if (SingleFileUpload.isImage(file.type)) {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
                this.setState({
                    imagePreviewUrl: fileReader.result
                });
            };
            fileReader.readAsDataURL(file);
        }
    }

    render() {

        const renderFilePreview = () => {
            if (this.state.selectedFile) {
                if (this.state.imagePreviewUrl) {
                    return <img src={this.state.imagePreviewUrl} className="image-preview" alt="Vorschau"/>
                } else {
                    return <i className="fa fa-file" aria-hidden="true"/>
                }
            } else {
                const currentValue = this.props.value;
                if (currentValue && _.isObject(currentValue) && _.get(currentValue, 'id')) {
                    if (_.get(currentValue, 'type') === 'image') {
                        return <img src={`${process.env.REACT_APP_API_ASSET_BASE_URL}/${currentValue.id}`}
                                    className="image-preview" alt="Bild"/>;
                    } else {
                        return <>
                            <i className="fa fa-file" aria-hidden="true"/><br/>
                            {currentValue.name}
                        </>
                    }
                } else {
                    return <i className="fa fa-cloud-upload" aria-hidden="true"/>
                }
            }
        };

        const accepts = this.props.accepts || '*/*'

        return (
            <div className="file-upload single" onClick={this.openFileDialog}
                 style={{cursor: this.isDisabled() ? "default" : "pointer"}}
            >
                <input
                    ref={this.fileInputRef}
                    className="file-input"
                    type="file"
                    accept={accepts}
                    onChange={this.onFileSelected}
                />

                <div className="preview">
                    {renderFilePreview()}
                </div>
                <div className="footer">
                    {this.props.label}
                    <button type="button" className="btn btn-secondary btn-sm delete-button"
                            onClick={(e) => {
                                this.remove();
                                e.stopPropagation();
                            }}>
                        <i className="fa fa-trash-o" aria-hidden="true"/>
                    </button>
                </div>

            </div>
        );
    }
}

SingleFileUpload.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.object,
    onChange: PropTypes.func,
    label: PropTypes.string
};

export default SingleFileUpload;
